var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M15 2v2h-9v-2h9zM16 1h-11v4h11v-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M0 1h4v4h-4v-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M15 7v2h-9v-2h9zM16 6h-11v4h11v-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M0 6h4v4h-4v-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M15 12v2h-9v-2h9zM16 11h-11v4h11v-4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M0 11h4v4h-4v-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormList);
export default __webpack_public_path__ + "static/media/form_list.24ff30bc952ccab7d84fd20f25a7c87c.svg";
export { ForwardRef as ReactComponent };